import { Location } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/providers/auth.service';
import { ChatbotService } from 'src/app/providers/chatbot.service';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  @ViewChild('scrollMe') private chatContainer!: ElementRef;
  @Input() leftPanel: boolean = true;

  chatMessages: any[] = [];
  userMessage: string = "";
  downloading = []
  processing = false
  isDev = 0
 
  currentPath: string = '';
  isDashboardV2: boolean = false;
  chatSubscription:Subscription

  constructor(private chatService: ChatbotService, private ar: ActivatedRoute, private authService: AuthService, private location: Location) {
    this.ar.queryParams.subscribe(res => {
      this.isDev = res.d ?? 0
    })
  }

  ngOnInit(): void {
    console.log(console.log(Number(this.isDev) ? 'dev' : 'uat'));
    this.currentPath = this.location.path();
    this.isDashboardV2 = this.currentPath.includes('dashboardv2');
    console.log('Current Path:', this.currentPath);


    this.chatService.getClearchatEVent().subscribe(val => {
      if (val) {
        this.clearChat()
      }
    })
  }

  sendMessage() {
    const { userId, email, merchantId } = this.authService.getUser;
    const userType = this.authService.getUserType()

    if (this.processing || !this.userMessage.trim()) {
      this.processing = false;
      return;
    }

    this.processing = true;

    this.chatMessages.push({ role: "user", content: this.userMessage });

    const assistantMessage = { role: "assistant", content: "Processing..." };
    this.chatMessages.push(assistantMessage);

    this.scrollToBottom();

    const userInput = this.userMessage;
    this.userMessage = "";

    const payload = {
      message: [...this.chatMessages.slice(0, -1)],
      userId,
      email,
      role: userType,
      entityId: merchantId
    };
    let isFirstChunk = true
    this.chatSubscription= this.chatService.masterChat(payload, this.isDev == 0 ? "dev" : "uat")
      .subscribe({
        next: (chunk: string) => {
          console.log(chunk);

          if (isFirstChunk) {
            this.chatMessages.pop();
            this.chatMessages.push({ role: "assistant", content: chunk });
            isFirstChunk = false;
          } else {
            this.chatMessages[this.chatMessages.length - 1].content += chunk;
          }
        },
        error: (err: any) => {
          console.error('Chat service error:', err);

          let errorMsg = 'I am unable to process your request.Please try again';

          if (err.status) {
            if (err.status === 502||err.status === 500) {
              errorMsg = 'Server down. Please contact support team.';
            }  
          } else if (err.error) {
            errorMsg = `Network error: ${err.error.message || err.error}`;
          }

          this.chatMessages.pop();
          this.chatMessages.push({ role: 'assistant', content: errorMsg });
          this.processing = false;
        }
        ,
        complete: () => {
          this.processing = false;
        }
      });
  }

  clearChat() {
    this.chatMessages = []
    this.userMessage = ""
    this.processing = false
    this.chatSubscription.unsubscribe()
  }

  downloadCsv(query, i) {
    this.downloading[i] = true
    const requestBody = { query: query[0], limit: true };
    this.chatService.downloadCsv(requestBody, this.isDev == 0 ? 'dev' : 'uat').subscribe((res => {
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(res);
      a.href = objectUrl;
      a.download = 'data.csv';
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
      this.downloading[i] = false
    }), err => {
      this.downloading[i] = false
    })
  }

  private scrollToBottom() {
    setTimeout(() => {
      this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
    }, 100);
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      this.sendMessage();
    }
  }

  ngOnDestroy() {
  if (this.chatSubscription) {
    this.chatSubscription.unsubscribe();
  }
}


}
